import { clsx } from "clsx";
import DefaultImage from "../../../assets/Images/BrandImage1.png";

export default function DesktopSidebarImageCard({
  isSidebarCustomized = false,
  isInteractionPending,
  name,
  image_url,
  handleCardClick,
  isDisabled,
  isActive,
  imageAdditionalClasses,
  collapsed = false,
}: {
  isSidebarCustomized?: boolean;
  image_url: string;
  name: string;
  handleCardClick: () => void;
  isDisabled?: boolean;
  isActive?: boolean;
  imageAdditionalClasses?: string;
  collapsed?: boolean;
  isInteractionPending?: boolean;
}) {
  return (
    <button
      type="button"
      key={name}
      disabled={isDisabled}
      onClick={handleCardClick}
      className={clsx(
        "group relative flex w-full items-center rounded-sm py-2 font-satoshi font-medium transition-colors disabled:cursor-not-allowed disabled:hover:bg-[#11202d] 2xl:rounded-md",
        // eslint-disable-next-line no-nested-ternary
        isActive ? (isSidebarCustomized ? "bg-[#22405a]" : "bg-[#333333]") : "",
        collapsed ? "justify-center" : "pl-4",
        isSidebarCustomized ? "hover:bg-[#22405a]" : "hover:bg-primary",
      )}
    >
      {isActive && !collapsed && <div className="absolute right-1 mr-2 h-2/3  w-0.5 rounded-xl bg-secondary 2xl:w-1" />}
      <img
        src={image_url || DefaultImage}
        className={clsx(
          "h-5 w-5 flex-shrink-0 rounded-md object-cover object-center 2xl:h-7 2xl:w-7 2xl:rounded-lg",
          imageAdditionalClasses,
        )}
        alt={name}
        aria-hidden="true"
      />
      {isInteractionPending && <div className="absolute right-2 top-2 aspect-1 h-2 rounded-full bg-accent " />}
      {/* No need to render text when item is collapsed */}
      {!collapsed && (
        <p title={name} className="ml-1 h-full truncate text-xs text-white first-letter:uppercase 2xl:ml-2 2xl:text-xs">
          {name}
        </p>
      )}
    </button>
  );
}
